import Logo from "./assets/Images/logo.png";
import { Link, NavLink, useLocation } from "react-router-dom";
import "./Header.scss";
import i18n from "i18next";
import { useTranslation, initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpApi from "i18next-http-backend";
import HamburgerMenu from "./assets/Images/hamburger.png";
import MobileNav from "./MobileNav";
import { useState } from "react";
import {
  Stack,
  Offcanvas,
  Container,
  Nav,
  Navbar as NavbarBs,
} from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .use(HttpApi)
  .init({
    lng: "en",
    fallbackLng: "en",

    detection: {
      order: ["path", "htmlTag", "cookie", "localStorage", "subdomain"],
      caches: ["cookie"],
    },

    backend: {
      loadPath: "/assets/locales/{{lng}}/translation.json",
    },

    react: { useSuspense: false },
  });

const languages = [
  {
    code: "en",
    name: "Eng",
  },
  {
    code: "ch1",
    name: "繁體",
  },
  {
    code: "ch2",
    name: "简体",
  },
];

const DropdownNavLink = ({ to, childPaths = [], children, ...props }) => {
  const location = useLocation();
  const isChildActive = childPaths.some(
    (p) => location.pathname === p || location.pathname.startsWith(p + "/"),
  );
  return (
    <NavLink
      to={to}
      className={({ isActive }) =>
        isActive || isChildActive ? "active" : undefined
      }
      {...props}
    >
      {children}
    </NavLink>
  );
};

const Header = () => {
  const { t } = useTranslation();

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <div style={{ zIndex: 9000 }} className="header fixed-top">
        <div className="header__items">
          <a href="/">
            <img src={Logo} alt="" />
          </a>
          <div className="header__links">
            <NavLink to="/" end>
              {t("home")}
            </NavLink>
            <div className="dropdown">
              <DropdownNavLink
                to="/about"
                childPaths={["/welcomemessage", "/constitution", "/contactus"]}
              >
                {t("hkas")}
              </DropdownNavLink>
              <div className="dropdown-content" style={{ width: "320px" }}>
                <Link to="/about" style={{ width: "280px" }}>
                  {t("about_hong_kong_arbitration_society")}
                </Link>
                <Link to="/welcomemessage" style={{ width: "280px" }} href="#">
                  {t("welcome_message")}
                </Link>
                <Link to="/constitution" style={{ width: "280px" }} href="#">
                  {t("constitution")}
                </Link>
                <Link to="/contactus" style={{ width: "280px" }} href="#">
                  {t("contact_us")}
                </Link>
                {/* <Link to="/joinus" style={{ width: "280px" }} href="#">
                  {t("join_us")}
                </Link> */}
              </div>
            </div>
            <div className="dropdown">
              <DropdownNavLink
                to="/whatisarbitration"
                childPaths={[
                  "/efficientarbitration",
                  "/whyhkasrules",
                  "/arbitrationclauses",
                  "/arbitrationagreement",
                  "/arbitrationsocietyrules",
                  "/arbitrationprocess",
                  "/hearingtimetable",
                  "/arbitrationfees",
                  "/enforcement",
                  "/arbitrationq&a",
                ]}
              >
                {t("arbitration")}
              </DropdownNavLink>
              <div className="dropdown-content" style={{ width: "320px" }}>
                <Link
                  to="/whatisarbitration"
                  style={{ width: "280px" }}
                  href="#"
                >
                  {t("what_is_arbitration")}
                </Link>
                <Link
                  to="/efficientarbitration"
                  style={{ width: "280px" }}
                  href="#"
                >
                  {t("what_is_efficient_arbitration")}
                </Link>
                <Link to="/whyhkasrules" style={{ width: "280px" }} href="#">
                  {t("why_hkas_rules?")}
                </Link>
                <Link
                  to="/arbitrationclauses"
                  style={{ width: "280px" }}
                  href="#"
                >
                  {t("arbitration_clauses")}
                </Link>
                <Link
                  to="/arbitrationagreement"
                  style={{ width: "280px" }}
                  href="#"
                >
                  {t("arbitration_agreement")}
                </Link>
                <Link
                  to="/arbitrationsocietyrules"
                  style={{ width: "280px" }}
                  href="#"
                >
                  {t("hong_kong_arbitration_society_rules")}
                </Link>
                <Link
                  to="/arbitrationprocess"
                  style={{ width: "280px" }}
                  href="#"
                >
                  {t("arbitration_process_page_header2")}
                </Link>
                <Link
                  to="/hearingtimetable"
                  style={{ width: "280px" }}
                  href="#"
                >
                  {t("hearing_timetable")}
                </Link>
                <Link to="/arbitrationfees" style={{ width: "280px" }} href="#">
                  {t("fees")}
                </Link>
                <Link to="/enforcement" style={{ width: "280px" }} href="#">
                  {t("enforcement")}
                </Link>
                <Link to="/arbitrationq&a" style={{ width: "280px" }} href="#">
                  {t("q&a")}
                </Link>
              </div>
            </div>

            <div className="dropdown">
              <a href="/odr">{t("online_arbitration")}</a>
            </div>

            <div className="dropdown">
              <DropdownNavLink
                to="/whymediation"
                childPaths={[
                  "/whatismediation",
                  "/mediationprocess",
                  "/whoneedsmediationservice",
                  "/mediationfees",
                  "/hkasmediationrules",
                  "/mpmhk",
                  "/q&a",
                ]}
              >
                {t("mediation")}
              </DropdownNavLink>
              <div className="dropdown-content" style={{ width: "390px" }}>
                <Link to="/whatismediation" style={{ width: "350px" }}>
                  {t("what_is_mediation")}
                </Link>
                <Link to="/whymediation" style={{ width: "350px" }} href="#">
                  {t("why_mediation")}
                </Link>
                <Link
                  to="/mediationprocess"
                  style={{ width: "350px" }}
                  href="#"
                >
                  {t("process_page_header2")}
                </Link>
                <Link
                  to="/whoneedsmediationservice"
                  style={{ width: "350px" }}
                  href="#"
                >
                  {t("who_needs_mediation_service")}
                </Link>
                <Link to="/mediationfees" style={{ width: "350px" }} href="#">
                  {t("fees")}
                </Link>
                <Link
                  to="/hkasmediationrules"
                  style={{ width: "350px" }}
                  href="#"
                >
                  {t("hong_kong_arbitration_society_mediation_rules")}
                </Link>
                <Link to="/mpmhk" style={{ width: "350px" }} href="#">
                  {t("mediation_practice_manual_for_hong_kong")}
                </Link>
                <Link to="/q&a" style={{ width: "350px" }} href="#">
                  {t("q&a")}
                </Link>
              </div>
            </div>
            {/* <Link to="/hkrenovationguideline">
              {t("hk_renovation_guideline")}
            </Link> */}
            <div className="dropdown">
              <DropdownNavLink
                to="/hkrenovationguideline"
                childPaths={[
                  "/decoration",
                  "/renovation1plushk",
                  "/decoacademy",
                ]}
              >
                {t("hk_renovation_guideline")}
              </DropdownNavLink>
              <div className="dropdown-content" style={{ width: "280px" }}>
                <Link to="/decoration" style={{ width: "240px" }} href="#">
                  {t("decoration")}
                </Link>
                <Link
                  to="/hkrenovationguideline"
                  style={{ width: "240px" }}
                  href="#"
                >
                  {t("hk_renovation_guideline")}
                </Link>
                <Link
                  to="/renovation1plushk"
                  style={{ width: "240px" }}
                  href="#"
                >
                  {t("renovation1plushk")}
                </Link>
                <Link to="/decoacademy" style={{ width: "240px" }} href="#">
                  {t("decoacademy")}
                </Link>
              </div>
            </div>
            <div className="dropdown">
              <DropdownNavLink
                to="/aboutcharter"
                childPaths={[
                  "/recognitionceremonyreview",
                  "/signthecharter",
                  "/listofparticipatinginstitutions",
                ]}
              >
                {t("harmony_hk")}
              </DropdownNavLink>
              <div className="dropdown-content" style={{ width: "280px" }}>
                <Link to="/aboutcharter" style={{ width: "240px" }} href="#">
                  {t("about_the_charter")}
                </Link>
                <Link
                  to="/recognitionceremonyreview"
                  style={{ width: "240px" }}
                  href="#"
                >
                  {t("recognition_ceremony_review")}
                </Link>
                <Link to="/signthecharter" style={{ width: "240px" }} href="#">
                  {t("sign_the_charter")}
                </Link>
                <Link
                  to="/listofparticipatinginstitutions"
                  style={{ width: "240px" }}
                  href="#"
                >
                  {t("list_of_participating_institutions")}
                </Link>
              </div>
            </div>
            <div className="dropdown">
              <DropdownNavLink
                to="/radioprogram"
                childPaths={["/societynews", "/sharelaw"]}
              >
                {t("society_information")}
              </DropdownNavLink>
              <div className="dropdown-content">
                <Link to="/radioprogram" href="#">
                  {t("radio_program")}
                </Link>
                <Link to="/societynews" href="#">
                  {t("blog")}
                </Link>
                <Link to="/sharelaw" href="#">
                  {t("share_law")}
                </Link>
              </div>
            </div>
          </div>
          <div className="select-language">
            {languages.map(({ name, code }) => (
              <span
                style={{ wordBreak: "keep-all" }}
                key={code}
                onClick={() => {
                  i18n.changeLanguage(code);
                }}
              >
                {name}
              </span>
            ))}
          </div>
          <div className="toogle__button">
            <img
              id="hamburger-icon"
              src={HamburgerMenu}
              alt=""
              onClick={handleShow}
            />
          </div>
          <div className="sidebar">
            <Offcanvas
              style={{ backgroundColor: "#AD172B", width: "300px" }}
              show={show}
              onHide={handleClose}
              placement="start"
            >
              <Offcanvas.Header closeButton>
                <Offcanvas.Title className="fs-3"></Offcanvas.Title>
              </Offcanvas.Header>
              <Offcanvas.Body>
                <Stack gap={5}>
                  <NavbarBs className="mb-3 ">
                    <Container>
                      <Nav className="me-auto d-flex flex-column fs-4">
                        <MobileNav onHide={handleClose} />
                      </Nav>
                    </Container>
                  </NavbarBs>
                </Stack>
              </Offcanvas.Body>
            </Offcanvas>
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
